// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

(function() {
M.View = M.View || {};
M.View.ProductDetails = M.View.ProductDetails || {};

/**
 * Page view for product details page
 */
M.View.ProductDetails.Page = Backbone.View.extend({
  events: {
    'click .btnLinksSample': 'displayAddSampleDialog',
    'click #actionLinks .btnLinksFav': 'toggleFavorite',
    'click .likeAction img': 'toggleFavorite',
    'click .btnLinksStoreFront' :'addToStorefront'
  },

  initialize: function() {
    M.required(this.options.sku);
    var that = this;
    this.$el = $(this.el);

    this._initializeCarousels();

    var $foilPressBadge = $('.foilPressBadge');

    this.productImage = new M.View.ProductDetails.PreviewImage({
      el: document.getElementById('product-images'),
      isGifAnimationEnabled: this.options.isGifAnimationEnabled
    });

    this.productImage.bind('shapeSelected', function(dieCutCode) {
      that.trigger("shapeSelected", dieCutCode);
    });

    this.productImage.bind('foilSelected', function(foilColor) {
      $foilPressBadge.removeClass();
      $foilPressBadge.addClass('foilPressBadge productBadge');
      $foilPressBadge.addClass(foilColor);
    });

    this._checkAndSetFavoriteStatus();
  },

  _initializeCarousels: function(size) {
    var that = this;

    // remove any existing controls for more views
    $('.jcarousel-control.moreViewsControl').empty();

    this.$('ul.moreViews').jcarousel({
      buttonNextHTML: null,
      buttonPrevHTML: null,
      size: size || that.$('ul.moreViews li img.altView').length,
      initCallback: M.carousel.buildCarouselControls,
      wrap: null,
      visible: 5,
      className: 'moreViews'
    });

    this.$('ul.matchingItems').jcarousel({
      buttonNextHTML: null,
      buttonPrevHTML: null,
      size: that.$('ul.matchingItems li img.altView').length,
      initCallback: M.carousel.buildCarouselControls,
      wrap: null,
      visible: 5,
      className: 'matchingItems'
    });
  },

  displayAddSampleDialog: function() {
    var selectedGreetingName = M.ProductDetails.getSelectedAltGreetingName();
    var greetingUrlParam = M.GetGreetingUrlParamFromName(selectedGreetingName);
    M.ProductDetails.showSampleDialog(greetingUrlParam);
  },

  addToStorefront : function() {
    var that = this;
    var url = '/photographer-storefront/add';
    var sku = this.options.sku;
    var data = {
      sku : sku
    };

    $.ajax({
      type: 'POST',
      url: url,
      data: data,
      success: function(data) {
        var isStorefront = JSON.parse(data);
        that._setStorefrontStatus(isStorefront);
      }
    });
  },

  _setStorefrontStatus: function(isStorefront) {
    if (isStorefront) {
      $('.btnLinksStoreFront').
        show().
        html('added to storefront').
        addClass('selected');

    } else {
      $('.btnLinksStoreFront').
        removeClass('selected');
    }
  },

  toggleFavorite: function(ev) {
    var that = this;
    var sku = this.options.sku;
    var $target = $(ev.target);
    var url = '/backbone/product/' + sku + '/favorite';

    var colorCode = M.ProductDetails.getSelectedColorCode();
    var dieCutCode = M.ProductDetails.getSelectedDieCutCode();
    var altGreeting = M.ProductDetails.getSelectedAltGreetingName();

    var data = {
      color_code: colorCode,
      die_cut_code: dieCutCode,
      alt_greeting: altGreeting
    };

    $.ajax({
      type: 'POST',
      url: url,
      data: data,
      success: function(data) {
        var isFavorited = JSON.parse(data);
        that._setFavoriteStatus(isFavorited);

        // Change the favorites count for heart icon in the header utility nav
        try {
          if (isFavorited) {
            window.ViewActions.incrementFavoritesNotViewedCount();
          } else {
            window.ViewActions.decrementFavoritesNotViewedCount();
          }
          // There a possible race condition, where the header Javascript code
          // is not intitialized before this part of the page.
        } catch(e) {
          console.log(e);
        }
      }
    });
  },

  _setFavoriteStatus: function(isFavorited) {
    if (isFavorited) {
      $('#actionLinks .btnLinksFav').
        html('added to favorites').
        addClass('selected');

      $('.likeAction img').
        addClass('likedIcon20').
        removeClass('likeIcon20');
    } else {
      $('#actionLinks .btnLinksFav').
        html('mark as favorite').
        removeClass('selected');

      $('.likeAction img').
        addClass('likeIcon20').
        removeClass('likedIcon20');
    }
  },

  /**
   * Checks to see if this sku is already favorited if so
   * update the favorite status.
   */
  _checkAndSetFavoriteStatus: function() {
    var sku = this.options.sku;
    var that = this;
    $.ajax({
      url: '/my-favorites/sku/' + sku,
      success: function(data) {
        var isFavorited = JSON.parse(data);
        that._setFavoriteStatus(isFavorited);
      }
    });
  },

  updateMoreViewForJournal: function(formatId) {
    var that = this;

    if (M.SKU.isNotebook(this.options.sku)) {
      var viewOptions = M.ProductDetails.getViewOptionsForJournal(formatId);

      this.productImage.updateViewCode(viewOptions[0].file_photo_code);

      var parts = that.options.sku.split('-');
      var context = {
        sku: that.options.sku,
        brand: parts[0],
        collection: parts[1],
        kind: parts[2],
        viewOptions: viewOptions,
        MINTEDCDN_HTTP_HOST: M.MINTEDCDN_HTTP_HOST
      };

      var html = M.Template.ProductDetails.ViewOption(context);

      this.$el.find('ul.moreViews').replaceWith(html);
      this._initializeCarousels(viewOptions.length);
    }
  }
});

})();
